/**
 * `useOsDarkMode` — thin back-compat wrapper around
 * `useThemePreference`.
 *
 * F20 of the Oatmeal rebuild shipped this hook as the OS-only
 * theme sync. Subsequent UX work introduced an explicit visitor
 * toggle (system / light / dark) and the canonical store moved
 * to `useThemePreference`. Existing call sites
 * (PilotLandingPage / MethodologyPage / PilotAdminPage) keep
 * calling this hook for its mount-time side effect; the hook now
 * just subscribes to the shared store so the same `<html>.dark`
 * writes happen, and `system` mode preserves the original
 * matchMedia-driven behavior.
 */

import {useThemePreference} from './useThemePreference';

export function useOsDarkMode(): void {
  // Subscribing is enough — useThemePreference applies the resolved
  // class + attribute to `<html>` on every render, and ensures the
  // OS media-query listener is bound once per session for `system`
  // mode.
  useThemePreference();
}
